import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { Maybe } from 'graphql/jsutils/Maybe';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Form_FormSequenceAnswerForwardsState } from '../../src/generated/graphql';
import { AveliosButton } from '../common-layout/avelios-button';

interface FormNavigationProps {
  next: () => void;
  previous: () => void;
  isFirst?: Maybe<boolean>;
  isBlacklisted?: Maybe<boolean>;
  forwardsState: Maybe<Form_FormSequenceAnswerForwardsState> | undefined;
  disabled?: boolean;
  loading?: boolean;
}

export const FormNavigation: FC<FormNavigationProps> = ({
  next,
  previous,
  forwardsState,
  isFirst,
  isBlacklisted,
  disabled,
  loading,
}) => {
  const { formatMessage } = useIntl();

  const complete =
    forwardsState === Form_FormSequenceAnswerForwardsState.FormSequenceAnswerForwardsStateComplete;

  const blocked =
    forwardsState === Form_FormSequenceAnswerForwardsState.FormSequenceAnswerForwardsStateBlocked;

  let nextText: string;
  if (complete) {
    if (isBlacklisted) {
      nextText = 'home';
    } else {
      nextText = 'survey.finish';
    }
  } else {
    nextText = 'next';
  }

  return (
    <Card>
      <AveliosButton
        loading={loading}
        icon={<LeftOutlined />}
        style={{ float: 'left' }}
        onClick={previous}
        disabled={disabled}
        size={'large'}
      >
        {formatMessage({ id: 'back' })}
      </AveliosButton>

      <AveliosButton
        loading={loading}
        icon={!complete && !isBlacklisted && <RightOutlined />}
        size={'large'}
        type={'primary'}
        disabled={disabled || blocked}
        style={{
          float: 'right',
        }}
        onClick={() => {
          next();
        }}
      >
        {formatMessage({ id: nextText })}
      </AveliosButton>
    </Card>
  );
};
